<template>
  <div class="app">
    <AppHeader fixed>
      <!-- <SidebarToggler class="d-lg-none" display="md" mobile /> -->
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/brand/small_landscape.png" width="140" height="50" alt="CoreUI Logo">
        <img class="navbar-brand-minimized" src="img/brand/small_landscape.png" width="30" height="30" alt="CoreUI Logo">
      </b-link>
      <!-- <SidebarToggler class="d-md-down-none" display="lg" /> -->
      <b-navbar-nav class="d-md-down-none">
        <b> SISTEMA DE CONSULTA Y PAGO EN LINEA </b>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <main class="main">
        <br>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <span class="ml-1">{{year}} - H. Ayuntamiento de El Salto.</span>
      </div>
      <div class="ml-auto">
        <span class="mr-1">Dirección de Tecnologías de la Información y Comunicación</span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import { Header as AppHeader, SidebarToggler, AsideToggler, Footer as TheFooter } from '@coreui/vue'

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    TheFooter,
    SidebarToggler
  },
  data () {
    return {
      
    }
  },
  computed: {
    year(){
      return new Date().getFullYear();
    },
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  }
}
</script>
